<template>
    <div>
        <div class="pattern" style="text-align: center; color: white; padding: 32px;">
            Please wait...
        </div>
    </div>
</template>
<script>
    export default {
        name: 'AffiliateComponent',
        components: { },
        data() {
            return {
            
            }
        },
    created() {
            let url = this.$config.api_url + "/My/Affiliate?id=" + this.$route.params.affiliate;
            if (this.$route.params.friend)
                url = url + "&t=2";

            this.axios.get(url).then((response) => {
                window.location.href = response.data; 
            }).catch(() =>  {
                this.$toast.error('Error Retrieving Affiliate, Please Try again');
                this.$router.push({ name: 'Store' });
            });
        }
    }
</script> 